import { NgModule } from '@angular/core';
import { PlainTextPipe } from './plain-text.pipe';

@NgModule({
  declarations: [PlainTextPipe],
  exports: [PlainTextPipe],
})
export class PipesModule {}
